import { initRequest } from './request.js';

const restApi = initRequest(process.env.BACKEND_API);

export async function retrieveOccoOwnerUserMyInfo() {
  return restApi.post('/occo-owner/user/my-info/retrieve', {}, { addAuth: true }).then((response) => {
    if (response.status === 'nok') return Promise.reject(response.error);
    return response.result;
  });
}

/**
 * @param {{ organisationId?: number|string; maxSize?: number; pageNumber?: number }} [params]
 * organisationId omitted = all events visible to the token (backend-dependent).
 */
export async function retrieveOccoOwnerEventList(params = {}) {
  const { organisationId, maxSize = 5000, pageNumber = 1 } = params;
  const body = { max_size: maxSize, page_number: pageNumber };
  if (organisationId != null) {
    body.organisation_id = organisationId;
  }
  return restApi.post('/occo-owner/event/basic-list/retrieve', body, { addAuth: true }).then((response) => {
    if (response.status === 'nok') return Promise.reject(response.error);
    return response.result;
  });
}
